import * as React from 'react';
import {
    Avatar,
    Button,
    Card,
    Col,
    Form,
    Input,
    Row,
    Space,
    Typography,
    notification,
} from 'antd';
import { useUserProfileQuery } from '../../../features/auth/authApi';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';
import PageTitle from '../../common/PageTitle';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Enums } from '../../../shared';

const { Paragraph } = Typography;

const UserProfileCard = (user) => {
    const { t } = useTranslation();

    const [issueCommand] = useIssueCommandMutation();

    const onOk = (values) => {
        const command = {
            type: Enums.COMMAND_TYPES.UPDATE_USER_PROFILE,
            ...values,
        };
        issueCommand({ command })
            .unwrap()
            .then(() => {
                notification.success({
                    message: t('success'),
                    description: t('profile.updated.success'),
                });
            })
            .catch((error) => {
                console.error(error);
                notification.error({
                    message: t('error'),
                    description: error.data?.message,
                });
            });
    };

    return (
        <Card bordered={false}>
            <Row>
                <Col span={4}>
                    <Avatar
                        size={128}
                        icon={<UserOutlined />}
                        src={user.data?.profile_picture}
                        style={{
                            margin: '0 auto',
                            display: 'block',
                            marginTop: '10px',
                        }}
                    />
                </Col>
                <Col span={20}>
                    <Form
                        layout="vertical"
                        initialValues={{
                            first_name: user.data?.first_name,
                            last_name: user.data?.last_name,
                            email: user.data?.email,
                        }}
                        onFinish={onOk}
                    >
                        <Form.Item label={t('profile.firstName')} name="first_name">
                            <Input />
                        </Form.Item>
                        <Form.Item label={t('profile.lastName')} name="last_name">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={t('profile.email')}
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ float: 'right' }}
                            >
                                {t('submit')}
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Card>
    );
};

const UserProfile = () => {
    const { data: user } = useUserProfileQuery('userDetails');

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle
                title={`👋 ${user.first_name ? user.first_name : user.email}`}
                actions={[]}
            />

            <UserProfileCard data={user} />
        </Space>
    );
};

export default UserProfile;
